import React from 'react';

const datasetContext = React.createContext({data: null}); // Create a context object

export {
  datasetContext // Export it so it can be used by other Components
};